import { IDBPDatabase } from 'idb'

import asyncForEach from 'utils/asyncForEach'

import { IDBSchema } from '../types'

/**
 * CHANGES:
 *
 * - Moved `lastSavedHash` from `scripts` table to `sessions` table
 * - Save `hash` of every script
 */

export default (
  database: IDBPDatabase<IDBSchema>,
  transaction: IDBTransaction,
  next: () => void
) => {
  STUDIO_ENV_DEVELOPMENT && console.log('---Running migration for v3---')

  const sessionsStore = transaction.objectStore('sessions')
  const scriptsStore = transaction.objectStore('scripts')

  // First, we get all sessions and scripts
  const sessionsRequest = sessionsStore.getAll()
  sessionsRequest.onsuccess = () => {
    const scriptsRequest = scriptsStore.getAll()
    scriptsRequest.onsuccess = () => {
      const sessions = sessionsRequest.result
      const scripts = scriptsRequest.result
      STUDIO_ENV_DEVELOPMENT && console.log('Found all sessions', sessions)
      STUDIO_ENV_DEVELOPMENT && console.log('Found all scripts', scripts)

      // Then, in each session, add its script's lastSavedHash to itself
      asyncForEach(
        sessions,
        (session, next) => {
          STUDIO_ENV_DEVELOPMENT && console.log('Updating session', session)
          const sessionScript = scripts.find(s => s.id === session.scriptId)
          if (!sessionScript) {
            session.lastSavedHash = ''
            return
          }
          STUDIO_ENV_DEVELOPMENT &&
            console.log('Adding lastSavedHash', sessionScript.lastSavedHash)
          sessionsStore.put({
            ...session,
            lastSavedHash: sessionScript.lastSavedHash || '',
          }).onsuccess = next
        },
        () => {
          // And delete the lastSavedHash from all scripts
          asyncForEach(
            scripts,
            (script, next) => {
              STUDIO_ENV_DEVELOPMENT && console.log('Updating script', script)
              STUDIO_ENV_DEVELOPMENT &&
                console.log('Removing lastSavedHash', script.lastSavedHash)
              delete script.lastSavedHash
              scriptsStore.put(script).onsuccess = next
            },
            () => {
              STUDIO_ENV_DEVELOPMENT && console.log('---Migrated to v3---')
              return next()
            }
          )
        }
      )
    }
  }
}
